import {
    IonButton, IonCheckbox, IonCol, IonContent, IonGrid, IonInput,
    IonItem, IonLabel, IonPage,
    IonPopover,
    IonRow, IonSelect,
    IonSelectOption, IonText, useIonViewWillEnter,
    useIonViewWillLeave
} from "@ionic/react";
import { useRef, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { Link } from "react-router-dom";
import Footer from "../../../components/Footer";
import { User } from "../../../models/data";
import { translation } from "../../../models/translation";
import { createDonation, fetchUserBalance_b } from "../../../services/donate_service";
import { fetchOrg, fetchOrgList } from "../../../services/org_service";
import { ymd } from "../../../utlities/ymd";
import UserTerms from "../../../components/UserTerms";

interface Props {
    user: User
}

const DonateToOrgCrd: React.FC<Props> = ({ user }) => {


    const siteText = translation();

    const lan = siteText.lan.replace("/", "")

    const location = useLocation()

    const params = new URLSearchParams(location.search)

    const OrgId = params.get('id');

    const history = useHistory();

    const [orgList, setOrgList] = useState<any[]>();


    const [disabled, setDisabled] = useState<boolean>(false);
    const [isProcesseng, setIsProcessing] = useState<string>()

    const tomorrow = new Date();

    tomorrow.setDate(new Date().getDate() + 1);

    const year = tomorrow.getFullYear();

    let month = `${tomorrow.getMonth() + 1}`;
    let day = `${tomorrow.getDate()}`;

    if (month.length < 2) { month = 0 + month };
    if (day.length < 2) { day = 0 + day };

    const minDate = `${year}-${month}-${day}`;



    const [orgChoice, setOrgChoice] = useState<any>({
        pickOrg: null,
    });


    const [altOrg, setAltOrg] = useState<any>()
    const [date, setDate] = useState<any>(minDate)
    const [freq, setFreq] = useState<string>('single')
    const [amount, setAmount] = useState<number>(() => { return 0 })
    const [anonymous, setAnonymous] = useState<boolean>(false)
    const [beneficiary_type, setBeneficiaryType] = useState<string>()
    const [balance, setBalance] = useState<number>(0);
    const [agreeToTerms, setAgreeToTerms] = useState<boolean>(false);

    const [org, setOrg] = useState<any>()
    const [orgPage, setOrgPage] = useState<any>()

    const popover = useRef<HTMLIonPopoverElement>(null);
    const [popoverOpen, setPopoverOpen] = useState(false);

    const toggleUserTerms = () => {
        let current = userTerms;
        showUserTerms(!current);
    }

    const [userTerms, showUserTerms] = useState<boolean>(false);


    const completeDonation = () => {
        setPopoverOpen(false)
        setTimeout(() => {
            history.push(`/${lan}/account/start`)
        }, 30)
    }
    useIonViewWillLeave(() => {

        setOrg(null)
        setOrgPage(null)
    })

    useIonViewWillEnter(() => {
        if (OrgId) getOrg()
    }, [OrgId])

    useIonViewWillEnter(() => {
        fetchCurrentUserBalance();
        getOrgList();
    })


    const getOrg = async () => {
        let orgPage = await fetchOrg(OrgId)
        setOrg(orgPage.message.acf[lan].rel_org)
        setOrgPage(orgPage.message)
        setOrgChoice({ pickOrg: orgPage.message.acf[lan].rel_org.ID })
    }

    const getOrgList = async () => {
        fetchOrgList().then(
            m => setOrgList(m.message)
        )
    }

    const updateOrg = (value: any) => {
        if (value !== "other") {
            setOrgChoice({ pickOrg: value })
            setBeneficiaryType('organisation');
            setAltOrg(null)
        } else {
            setBeneficiaryType('other')
            setOrgChoice({ pickOrg: null })


        }
    }

    /** */
    const fetchCurrentUserBalance = async () => {

        await fetchUserBalance_b(user.id).then(
            m => {
                if (!m?.error) {
                    setBalance(m?.message)
                }
            }
        );

    }



    const onSubmit = (event: any) => {

        event.preventDefault();

        setDisabled(!disabled)
        setIsProcessing('processing')
        setPopoverOpen(true)

        createDonation({
            title: `${user.firstName}_on_${month}_${day} # ${Math.floor(Math.random() * 60)}`,
            status: "publish",
            acf: {
                status: "completed",
                beneficiary: orgChoice.pickOrg,
                altOrg: altOrg,
                beneficiary_type: beneficiary_type,
                anonymous: `${anonymous}`,
                amount: amount,
                tip: 0,
                commission: 0,
                date: ymd(date.date),
                donation_method: "sw_account",
                frequency: freq
            }
        }).then(m => {
            if (!m?.message) {
                setIsProcessing('error')
                console.log(m)
            } else {
                setIsProcessing('done')
            }
        })

    }

    return (
        <>

            <IonPage>
                <IonContent>
                    {!userTerms ?


                        <IonGrid className="innerBody sw_sp_md">
                            <IonRow>
                                <IonCol offsetSm="1" offsetMd="1" sizeSm="10" sizeMd="8" >
                                    {!OrgId && <h1 className="h2">{siteText.donateUseCreditStartTitle}</h1>}
                                    {orgPage && <h1 className="h2">{siteText.fundraiseDonateStartTitle.replace("%%title%%", orgPage.title.rendered)}</h1>}
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol className="ion-margin-top" offsetSm="1" offsetMd="1" sizeSm="10" sizeMd="8">
                                    <p>{siteText.donateUseCreditStartIndication.replace("%%amount%%", balance.toString())}</p>
                                    <form onSubmit={onSubmit}>
                                        <IonLabel position="stacked">{siteText.donateUseCreditDetailsAmountLabel}</IonLabel>

                                        <IonItem lines="none" className="cashField ion-margin-top ion-margin-bottom">
                                            <IonInput onIonChange={(e: any) => setAmount(+e.detail.value)}
                                                value={amount ? +amount : 0} placeholder={siteText.donateUseCreditDetailsAmountPhl} min={0} type="number"></IonInput>
                                            <IonText>CHF</IonText>
                                        </IonItem>

                                        {!OrgId &&
                                            <>
                                                <IonLabel>{siteText.donateUseCreditDetailsBenLabel}</IonLabel>
                                                <IonSelect mode="md" interface="popover" disabled={OrgId && OrgId?.length > 0 ? true : false} className="ion-margin-bottom ion-margin-top" value={orgChoice.pickOrg ? orgChoice.pickOrg : 'other'} okText="Ok" cancelText="Dismiss" onIonChange={(e: any) => updateOrg(e.detail.value)}>
                                                    <IonSelectOption value="other">{siteText.donateUseCreditDetailsBeneficiaryOpt}</IonSelectOption>
                                                    {orgList?.map((m: any, key) => {
                                                        return <IonSelectOption key={key} value={m.id}>{m.title.rendered}</IonSelectOption>
                                                    })}


                                                </IonSelect>
                                            </>}
                                        {
                                            !orgChoice.pickOrg && <>
                                                <IonLabel position="stacked">{siteText.donateUseCreditDetailsBeneficiaryAltLabel}
                                                </IonLabel>
                                                <IonInput value={altOrg} onIonChange={(e: any) => setAltOrg(e.detail.value)} className="ion-margin-bottom ion-margin-top" placeholder={siteText.donateUseCreditDetailsAltBeneficiaryPlh} required={(!orgChoice.pickOrg) ? true : false}></IonInput>
                                            </>

                                        }
                                        <IonItem lines="none" className="borderedInput">
                                            <IonLabel>
                                                {siteText.donateUseCreditDetailsAnonymousCheck}
                                            </IonLabel>
                                            <IonCheckbox onIonChange={(e: any) => setAnonymous(e.detail.checked)} checked={anonymous} slot="start" />
                                        </IonItem>

                                        <IonItem lines="none" className="borderedInput ion-margin-top">
                                            <IonLabel>
                                                <Link to="terms_of_use" onClick={e => { e.preventDefault(); toggleUserTerms(); }}>{siteText.donateUseCreditDetailsTermsConfrim}</Link>
                                            </IonLabel>
                                            <IonCheckbox slot="start" checked={agreeToTerms} onIonChange={e => setAgreeToTerms(e.detail.checked)} />

                                        </IonItem>
                                        {balance < amount && <p><IonText color="danger">{siteText.donateUseCreditStartInsufficientCr}</IonText></p>}
                                        <IonButton type="submit" strong disabled={!agreeToTerms || amount === 0 || (balance<amount)} className="ion-margin-top">
                                            <IonText color="light">{siteText.donateUseCreditDetailsPrimary}</IonText>
                                        </IonButton>
                                        {balance <amount &&
                                            <IonButton fill="outline" className="ion-margin-top" type="button" routerLink={`/${lan}/account/credit`}>
                                                <IonText>{siteText.donateUseCreditAltTxt}</IonText>
                                            </IonButton>
                                        }
                                    </form>
                                </IonCol>
                            </IonRow>
                            <IonPopover ref={popover} isOpen={popoverOpen} backdropDismiss={false}>
                                <IonContent>
                                    <IonGrid>
                                        <IonRow className="ion-padding">
                                            {isProcesseng === 'processing' &&
                                                <IonCol size="12">{siteText.donateUseCreditDetailsProcessing}</IonCol>}
                                            {isProcesseng === 'done' && <IonCol size="12">
                                                <p>{siteText.donateUseCreditDetailsSuccess}
                                                </p>
                                                <IonButton color="success" onClick={completeDonation}> <IonText color="light">{siteText.donateUseCreditDetailsDoneString}</IonText> </IonButton>
                                            </IonCol>}
                                            {isProcesseng === 'error' && <IonCol size="12">
                                                <p>{siteText.donateUseCreditDetailsError}
                                                </p>
                                                <IonButton color="secondary" onClick={e => setPopoverOpen(false)}><IonText color="light">{siteText.donateUseCreditDetailsTryAgainString}</IonText> </IonButton>
                                            </IonCol>}
                                        </IonRow>
                                    </IonGrid>
                                </IonContent>
                            </IonPopover>
                        </IonGrid> : <UserTerms goBack={toggleUserTerms} ></UserTerms>}
                    <Footer></Footer>
                </IonContent>
            </IonPage>



        </>

    )



}

export default DonateToOrgCrd;